import { useMemo } from 'react';

import PickUpPointTag from '@Promo/elems/PickUpPointTag';
import LinearTag from '@Promo/elems/LinearTag';
import FullСashbackTag from '@Components/FullCashbackTag';
import PromocodeTag from '@Promo/elems/PromocodeTag';

import type { FC, HTMLAttributes, ReactElement } from 'react';
import type { ProductData } from '@Types/Product';

interface MarketingTagProps extends HTMLAttributes<HTMLDivElement> {
  product: ProductData;
  tagAnimation?: boolean;
  fallback?: () => ReactElement;
}

type MarketingTagType = 'pickUpPoint' | 'extraSale' | 'kits' | 'cashback' | 'promocode';

const MarketingTag: FC<MarketingTagProps> = (props) => {
  const { product, tagAnimation, fallback, ...restProps } = props;
  const { hasPickUpPoint, extraDiscountTag, hasKitActivity, extraBonus, couponCode } = product;

  const tag: MarketingTagType | null = useMemo(() => {
    if (hasPickUpPoint) return 'pickUpPoint';
    if (extraDiscountTag) return 'extraSale';
    if (hasKitActivity) return 'kits';
    if (extraBonus) return 'cashback';
    if (couponCode) return 'promocode';
    return null;
  }, [couponCode, extraBonus, extraDiscountTag, hasKitActivity, hasPickUpPoint]);

  switch (tag) {
    case 'pickUpPoint': {
      return <PickUpPointTag {...restProps} size='s' color='light' />;
    }
    case 'extraSale': {
      return (
        <LinearTag
          {...restProps}
          type='extra'
          animation={tagAnimation}
          tagData={extraDiscountTag}
        />
      );
    }
    case 'kits': {
      return <LinearTag {...restProps} type='kits' animation={tagAnimation} />;
    }
    case 'cashback': {
      return <FullСashbackTag {...restProps} view='fat' isHidePopup />;
    }
    case 'promocode': {
      return <PromocodeTag {...restProps} data={couponCode} animation={tagAnimation} />;
    }
    default: {
      if (fallback) return fallback();
      return null;
    }
  }
};

export default MarketingTag;
